angular
  .module("alk.translations")
  .constant("LOCALES", {
    "locales": {
      "en_US": "English"
      // "es_ES": "Espanol",
      // "de_DE": "Deutsch"
    }
  });

angular
  .module("alk.translations")
  .service("alkLocaleService", ["$translate", "LOCALES", "$rootScope", "tmhDynamicLocale", "$http", "$templateCache", function ($translate, LOCALES, $rootScope, tmhDynamicLocale, $http, $templateCache) {
    "use strict";
    // VARS
    var localesObj = LOCALES.locales;

    // locales and locales display names
    var _LOCALES = Object.keys(localesObj);
    if (!_LOCALES || _LOCALES.length === 0) {
      console.error("There are no _LOCALES provided");
    }
    var _LOCALES_DISPLAY_NAMES = [];
    _LOCALES.forEach(function (locale) {
      _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
    });

    var currentLocale = $translate.proposedLanguage() || $translate.use();

    // on initial load of the app, make sure to set the custom alk-language header as well as update the html attribute to be correct as per the language currently showing.
    $http.defaults.headers.common["ALK-Language"] = currentLocale;
    document.documentElement.setAttribute("lang", currentLocale);

    // METHODS
    var checkLocaleIsValid = function (locale) {
      return _LOCALES.indexOf(locale) !== -1;
    };

    var setLocale = function (locale) {
      if (!checkLocaleIsValid(locale)) {
        console.error("Locale name '" + locale + "' is invalid");
        return;
      }
      startLoadingAnimation();
      currentLocale = locale;
      $translate.use(locale);
    };

    /**
     * Stop application loading animation when translations are loaded
     */
    var $html = angular.element("html");
    var LOADING_CLASS = "app-loading";

    function startLoadingAnimation() {
      $html.addClass(LOADING_CLASS);
    }

    function stopLoadingAnimation() {
      $html.removeClass(LOADING_CLASS);
    }

    // EVENTS
    $rootScope.$on("$translateChangeSuccess", function (event, data) {
      document.documentElement.setAttribute("lang", data.language); // sets "lang" attribute to html
      $http.defaults.headers.common["ALK-Language"] = data.language;

      // this ensures that any pages that were using language specific view are no longer cached. example of this is the terms of use template
      // TODO: come up with more robust way to remove all [[language]] templates
      $templateCache.remove("templates/[[language]]/terms.html");

      tmhDynamicLocale.set(data.language.toLowerCase().replace(/_/g, "-")); // load Angular locale
    });

    $rootScope.$on("$localeChangeSuccess", function (e, locale) {
      stopLoadingAnimation();
    });

    return {
      getLocaleDisplayName: function () {
        return localesObj[currentLocale];
      },
      setLocaleByDisplayName: function (localeDisplayName) {
        setLocale(
          _LOCALES[
            _LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName) // get locale index
          ]
        );
      },
      getLocalesDisplayNames: function () {
        return _LOCALES_DISPLAY_NAMES;
      }
    };
  }]);



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-translations/alkLocaleService.js